<!--选择供方单位-->
<template>
    <div class="selectOrg">
        <van-action-sheet v-model="show" title="">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=""
                @load="onLoad"
            >
                <van-cell
                    v-for="item in orgList"
                    :key="item.org_code"
                    :title="item.org_name"
                    @click="handleSelect(item)"
                >
                </van-cell>
            </van-list>
        </van-action-sheet>
    </div>
</template>

<script>
export default {
    name: 'select-org',
    data() {
        return {
            show: false,
            loading: false,
            finished: false,
            pageindex: 0,
            pagesize: 10,
            orgList: [],
        };
    },
    created() {
        this.onLoad();
    },
    methods: {
        onLoad() {
            this.loading = true;
            this.pageindex++;
            this.$axios.post('/interfaceApi/sale/settlement_company/get_settlement_company_list',
                {
                    keyword: '',
                    pageindex: this.pageindex,
                    pagesize: this.pagesize,
                })
                .then(data => {
                    if (data.total > this.orgList.length) {
                        this.orgList.push(...data.rows);
                    } else {
                        this.finished = true;
                    }
                    this.loading = false;
                });
        },
        handleSelect(item) {
            this.$emit('change', item);
            this.show = false;
        },
    },
};
</script>

<style lang="stylus" scoped>
.selectOrg
    width 100%
    height 100%
    position fixed;
    z-index 999;
    >>> .van-cell
        text-align center;
        &:after
            display none;
    >>> .van-action-sheet__content
        height 30vh;
        overflow-y auto;
</style>
